module.exports = __webpack_public_path__ + "static/embedded_tucepi-ebd8d61570e141621ddd911ac753d062.svg";